import { Component, Input, OnInit } from '@angular/core';
import { UrlService } from '@utils/services/url/url.service';
import {ImageService} from "@utils/services/image/image.service";
import {EnvironmentService} from '@utils/services/environment/environment.service';

@Component({
  selector: 'lib-hero-banner',
  templateUrl: './hero-banner.component.html',
  styleUrls: ['./hero-banner.component.scss'],
})
export class HeroBannerComponent implements OnInit {
  @Input() public linkSubDomain: string;
  @Input() public linkPath: string;
  @Input() public title: string;
  @Input() public leagueName: string;
  @Input() public hasTopShadow = true;
  @Input() public link = UrlService.Web;
  @Input() public borderRadius = '5px';
  @Input() public disableVotingBanner = false;
  @Input() public showBackground = true;
  public logo = ImageService.StaticImages.Logo.NewOnGreen;
  public show = false;

  public ngOnInit(): void {
    this.show = EnvironmentService.isWidget;
    if (!this.show) {
      return;
    }
    if (!this.title) {
      this.title = 'Alle Spiele und Ticker auf';
      if (this.leagueName?.length > 0) {
        this.title = `Folge der ${this.leagueName} auf`;
      }
    }
    if (!this.showBackground) {
      this.logo = ImageService.StaticImages.Logo.BlueGreen;
    }
    if (this.linkSubDomain?.length > 0) {
      this.link = UrlService.getSubdomainUrl(this.linkSubDomain, this.linkPath);
      return;
    }
    if (this.linkPath?.length > 0) {
      this.link = UrlService.useUtmParams(
        `https://${UrlService.Urls.webHost}/${this.linkPath}`
      );
    }
  }
}
